/* eslint-disable no-lonely-if */
import { RANGE_FILTER_SEPARATOR } from '@aibees/elephant/constants/filters';
import { SearchBrowseParams } from '@aibees/elephant/types';

export function buildDraft(
  field: string,
  params: Partial<SearchBrowseParams>,
  checked: boolean
) {
  let draft = params[field]?.split(RANGE_FILTER_SEPARATOR) ?? [];
  if (checked) draft[1] = 'Present';
  else draft = [draft[0]];
  return draft.join(RANGE_FILTER_SEPARATOR);
}
